<template lang="pug">
.search-header
	form.search-header__form(@submit.prevent="")
		.search-header__input-wrapper
			input#locations-listing__autocomplete.search-header__input(
				type="text",
				placeholder="Search City, State or Zip Code",
				@keydown.enter.prevent="handleFormSubmit($event)"
				required)
			i.glyph-search_thin.search-header__icon
		button.search-header__submit.btn(type="submit", @click.prevent="handleFormSubmit($event)") Search
</template>

<script>
import failAlert from "../../global/mixins/locationsListingFailAlert";
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
	name: "SeachHeader",
	components: {},
	props: {
		presearchZipcode: String
	},
	data() {
		return {
			autocomplete: null,
			inputEl: null,
			predictions: null,
			lastKey: null
		};
	},
	computed: {
		...mapGetters([
			"apiKey",
			"google",
			"placesService"
		]),
	},
	methods: {
		...mapMutations([
			"setStateValue",
		]),
		...mapActions([
			"sendLocationRequest",
		]),
		fail() {
			failAlert()
		},
		findPlace(request) {
			let that = this;
			this.placesService.findPlaceFromQuery(request, async function(results, status) {
				if (status === google.maps.places.PlacesServiceStatus.OK) {
					if (!!results && results.length > 0) {
						that.setStateValue(['lat', results[0].geometry.location.lat()]);
						that.setStateValue(['lng', results[0].geometry.location.lng()]);
						that.inputEl.value = results[0].name;
						that.sendLocationRequest();
					} else {
						failAlert();
					}
				} else {
					failAlert();
				}
				that.$emit("nullifyZip");
			});
		},
		async handleFormSubmit(e) { // executes if search button is pressed, but enter code check skips this function b/c enter key press triggers place_changed event automatically
			if (e.code == "Enter" || e.code == "NumpadEnter") return;
			let request = {
					query: this.inputEl.value,
					fields: ['name', 'geometry.location'],
				};
			this.findPlace(request);
		},
		async handlePlaceChange() {
			this.setStateValue(["page", null]);
			let place = this.autocomplete.getPlace();
			if (!place || !place.geometry) {
				let request;
				if (this.presearchZipcode) {
					request = {
						query: this.presearchZipcode,
						fields: ['name', 'geometry.location'],
					};
					this.inputEl.value = this.presearchZipcode;
				} else {
					request = {
						query: this.inputEl.value,
						fields: ['name', 'geometry.location'],
					};
				}
				this.findPlace(request)
			} else {
				this.setStateValue(['lat', place.geometry.location.lat()]);
				this.setStateValue(['lng', place.geometry.location.lng()]);
				this.sendLocationRequest();
			}
		},
	},
	mounted() {
		this.inputEl = this.$el.querySelector("#locations-listing__autocomplete");
		this.autocomplete = new this.google.maps.places.Autocomplete(
			this.inputEl,
			{
				componentRestrictions: {'country': ['US']},
				fields: [
					'geometry'
				],
				types: [
					'geocode'
				]
			}
		);
		this.autocomplete.addListener('place_changed', () => this.handlePlaceChange());

		if (this.presearchZipcode) {
			this.handlePlaceChange();
		}
	},
};
</script>

<style scoped lang="scss">
.search-header {
	margin-bottom: 66px;
	@include mqdn(sm_dn) {
		margin-bottom: 48px;
	}
}
</style>